import { render, staticRenderFns } from "./CheckoutForm.vue?vue&type=template&id=1d882175&scoped=true&"
import script from "./CheckoutForm.vue?vue&type=script&lang=js&"
export * from "./CheckoutForm.vue?vue&type=script&lang=js&"
import style0 from "./CheckoutForm.vue?vue&type=style&index=0&id=1d882175&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d882175",
  null
  
)

/* custom blocks */
import block0 from "./../../i18n/checkout_form.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fapp%2Fsrc%2Fcomponents%2Fbasket%2FCheckoutForm.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports